<template>
    <modal dialog="modal-lg" class="dark-top" :footer="false" :headerStyle="{'background-color':currentIntegration.color.main}">
        <div slot="title">
            <h2>Viator</h2>
        </div>

        <div slot="body">
            <top-area :integration="currentIntegration" />
            <state-label v-if="currentIntegration.integrationStatus != 1" :integration="currentIntegration" @close="close()" />

            <div class="px-5 pt-3 pb-4">
                <div v-if="currentIntegration.integrationStatus == 1" class="mb-4 pb-2">
                    <label>Integration Key</label>
                    <input type="text" v-model="currentIntegration.apiKey" class="w-100" disabled>
                </div>

                <bottom-area
                    :isIntegrated="currentIntegration.integrationStatus == 1"
                    @disableIntegration="disableIntegration()"
                    @close="closeModal()"
                />
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import Modal from '@/tools/modal/Modal'
    import topArea from './popupParts/topArea'
    import bottomArea from './popupParts/bottomArea'
    import stateLabel from './popupParts/stateLabel'

    export default {
        data() {
            return {}
        },
        computed: {
            ...mapGetters([
                'getSelectedIntegration'
            ]),
            currentIntegration() {
                return this.getSelectedIntegration;
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'enableOrDisableViatorIntegration',
                'createViatorIntegration'
            ]),
            disableIntegration() {
                this.enableOrDisableViatorIntegration(false);
                this.close();
            },
            close() {
                this.closeModal();
            },
        },
        components: {
            topArea,
            bottomArea,
            Modal,
            stateLabel
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// viatorIntegrate.vue?2521d406